import React from "react";
import { StatusBanner } from "../../molecules/StatusBanner";
import { ModelReviewDialog } from "../ModelReviewDialog";
import type { ModelStatusBannerProps } from "./ModelStatusBanner.types";
import { useModelStatusBannerState } from "./useModelStatusBannerState";

/**
 * Where the tenant's data model stands, for a tenant on the new architecture; nothing once it's
 * ready. A tenant admin reviews a held update from it.
 */
export const ModelStatusBanner: React.FC<ModelStatusBannerProps> = ({ placement, className }) => {
  const { banner, review } = useModelStatusBannerState(placement);
  return (
    <>
      {banner ? <StatusBanner {...banner} className={className} /> : null}
      <ModelReviewDialog {...review} />
    </>
  );
};

export default ModelStatusBanner;
